import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Button, Input, Label, Table, Spinner } from "reactstrap";

// (2026-10) Archivos del prospecto (cotizaciones, fotos, fichas, Excel...):
// se suben varios a la vez y quedan guardados en el prospecto.
const URL = process.env.REACT_APP_URL_CRM_PROSPECTOS;
const auth = () => ({ headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } });

const icono = (a) => {
  const t = String(a.tipo || "");
  if (t.startsWith("image/")) return "far fa-file-image";
  if (t === "application/pdf" || /\.pdf$/i.test(a.nombre)) return "far fa-file-pdf";
  if (/sheet|excel|csv/i.test(t) || /\.(xlsx?|csv)$/i.test(a.nombre)) return "far fa-file-excel";
  if (/word/i.test(t) || /\.docx?$/i.test(a.nombre)) return "far fa-file-word";
  return "far fa-file";
};

function ArchivosProspecto({ idProspecto, puedeEditar }) {
  const [archivos, setArchivos] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [elegidos, setElegidos] = useState([]);
  const [subiendo, setSubiendo] = useState("");
  const [inputKey, setInputKey] = useState(0);

  useEffect(() => {
    if (!idProspecto) return;
    setCargando(true);
    axios
      .get(`${URL}/${idProspecto}/archivos`, auth())
      .then((r) => setArchivos(r.data || []))
      .catch((e) => console.log(e))
      .finally(() => setCargando(false));
  }, [idProspecto]);

  const subir = async () => {
    const lista = [...elegidos];
    const fallas = [];
    for (let i = 0; i < lista.length; i++) {
      setSubiendo(`Subiendo ${i + 1} de ${lista.length}...`);
      const fd = new FormData();
      fd.append("file", lista[i]);
      try {
        const { data } = await axios.post(`${URL}/${idProspecto}/archivos`, fd, auth());
        setArchivos(data || []);
      } catch (e) {
        fallas.push(`${lista[i].name}: ${e.response?.data?.message || "no se pudo subir"}`);
      }
    }
    setSubiendo("");
    setElegidos([]);
    setInputKey((k) => k + 1);
    if (fallas.length) Swal.fire("Algunos no se subieron", fallas.join("<br/>"), "warning");
  };

  const borrar = async (a) => {
    const r = await Swal.fire({
      title: "¿Borrar el archivo?",
      text: a.nombre,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, borrar",
      cancelButtonText: "No",
    });
    if (!r.isConfirmed) return;
    try {
      const { data } = await axios.delete(`${URL}/${idProspecto}/archivos/${a._id}`, auth());
      setArchivos(data || []);
    } catch (e) {
      Swal.fire("Error", e.response?.data?.message || "No se pudo borrar", "error");
    }
  };

  return (
    <div>
      <Label>Archivos</Label>
      {cargando ? (
        <div>
          <Spinner size="sm" color="primary" />
        </div>
      ) : archivos.length ? (
        <Table size="sm" borderless striped className="mb-2">
          <tbody>
            {archivos.map((a) => (
              <tr key={a._id}>
                <td style={{ width: 28 }}>
                  <i className={icono(a)} style={{ color: "#003A5C" }}></i>
                </td>
                <td>
                  <a href={a.url} target="_blank" rel="noopener noreferrer">
                    {a.nombre}
                  </a>
                </td>
                <td className="text-muted" style={{ fontSize: 12, whiteSpace: "nowrap" }}>
                  {a.fecha}
                  {a.usuario ? ` · ${a.usuario}` : ""}
                </td>
                <td style={{ width: 40 }}>
                  {puedeEditar ? (
                    <Button size="sm" color="danger" title="Borrar archivo" onClick={() => borrar(a)}>
                      <i className="fas fa-times"></i>
                    </Button>
                  ) : null}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <p className="text-muted" style={{ fontSize: 13 }}>
          Sin archivos todavía.
        </p>
      )}
      {puedeEditar ? (
        <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
          <Input
            key={inputKey}
            type="file"
            multiple
            style={{ flex: "1 1 260px" }}
            onChange={(e) => setElegidos(Array.from(e.target.files || []))}
            disabled={!!subiendo}
          />
          <Button color="info" size="sm" onClick={subir} disabled={!elegidos.length || !!subiendo}>
            {subiendo || `Subir${elegidos.length ? ` (${elegidos.length})` : ""}`}
          </Button>
        </div>
      ) : null}
    </div>
  );
}

export default ArchivosProspecto;
